// https://vuex.vuejs.org/en/mutations.html

import { set } from "@/utils/vuex";

export default {
  setUser(state, payload) {
    state.user = payload;
  },
  setUserPartnerProgram(state, payload) {
    state.isUserPartnerProgram = payload;
  },
  setUserStakingWallet(state, payload) {
    if (state.user == null) {
      return;
    }
    state.user.staking_wallet = payload;
  },
  setModuleDefiIndexStats(state, payload) {
    state.moduleDefiIndexStats = payload;
  },
  setModuleDefiIndexes(state, payload) {
    state.moduleDefiIndexes = payload;
  },
  setUserPhone(state, payload) {
    if (state.user == null) {
      return;
    }
    state.user.obfuscated_phone = payload;
  },
  setFreePack(state, payload) {
    if (state.user == null) {
      return;
    }
    state.user.free_pack = payload;
  },
  updateUser() {},
  setUserSettings: set("userSettings"),
  setSubscription: set("subscription"),
};
